export default __webpack_public_path__ + "static/media/mainpage.5bd0746d.png";